var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grand-tour"}},[_c('div',{ref:"ruler",attrs:{"id":"one-to-ruler-them-all"}},[_c('span')]),_c(_vm.literallyStyle,{tag:"component",domProps:{"textContent":_vm._s(_vm.fontFaces)}}),_c('ControlPanel'),_c('MasterLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }